import React, { Fragment } from 'react';
import { getRefinedDeliveryEstimatedDate } from '../../../app/Helper/DeliveryHelper';

function DeliveryEstimatedDateTemplate({
  expectedDeliveryEndDate,
  averageDeliveryDays,
  fixedText,
  isLotteDeal,
  toolTipText,
}) {
  return (
    <Fragment>
      {fixedText ? (
        // 고정문구가 있을 경우
        <div>
          {isLotteDeal ? (
            <Fragment>
              배송일 평균 <span className="text_color1">5</span>일 정도 소요
              예정
            </Fragment>
          ) : (
            fixedText
          )}
        </div>
      ) : (
        // 고정문구가 없을 경우
        (expectedDeliveryEndDate || averageDeliveryDays) && (
          <div>
            {expectedDeliveryEndDate && (
              <Fragment>
                <span className="text_color1">{expectedDeliveryEndDate}</span>{' '}
                이내 도착 예정
              </Fragment>
            )}
            {averageDeliveryDays &&
              (expectedDeliveryEndDate
                ? `(평균 배송일 ${averageDeliveryDays}일)`
                : `평균 배송일 ${averageDeliveryDays}일`)}
            {toolTipText && TMON.sDevice === 'PW' && (
              <div className="default_tip">
                <span className="btn_help_tip">배송 정보</span>
                <div className="pop_tooltip_sale">
                  <div className="inner">
                    <p className="txt">{toolTipText}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )
      )}
    </Fragment>
  );
}

function DeliveryEstimatedDatePostDealTemplate({
  expectedDeliveryEndDate,
  averageDeliveryDays,
  postConditionText,
  toolTipText,
}) {
  return (
    <Fragment>
      {postConditionText && <div>{postConditionText}</div>}
      {(expectedDeliveryEndDate || averageDeliveryDays) && (
        <div>
          {expectedDeliveryEndDate && (
            <Fragment>
              [택배배송]{' '}
              <span className="text_color1">{expectedDeliveryEndDate}</span>{' '}
              이내 도착 예정{' '}
            </Fragment>
          )}
          {averageDeliveryDays &&
            (expectedDeliveryEndDate
              ? `(평균 배송일 ${averageDeliveryDays} 일)`
              : `평균 배송일 ${averageDeliveryDays} 일`)}
          {toolTipText && TMON.sDevice === 'PW' && (
            <div className="default_tip">
              <span className="btn_help_tip">배송 정보</span>
              <div className="pop_tooltip_sale">
                <div className="inner">
                  <p className="txt">{toolTipText}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div>
        [우편배송]{' '}
        {expectedDeliveryEndDate ? (
          <Fragment>
            <span className="text_color1">{expectedDeliveryEndDate}</span> 이내
            발송 예정 (발송 후 3~15영업일 배송소요)
          </Fragment>
        ) : (
          '발송 후 3~15영업일 배송소요'
        )}
      </div>
    </Fragment>
  );
}

/**
 * 배송 도착예정일 컴포넌트
 */
function DeliveryEstimatedDate() {
  const { isPurchaseAvailable, htDealInfo } = TMON.htStaticData;

  const refinedData = getRefinedDeliveryEstimatedDate(htDealInfo);

  if (!refinedData) {
    return null;
  }

  const {
    expectedDeliveryEndDate,
    averageDeliveryDays,
    fixedText,
    isLotteDeal,
    isPostDeal,
    postConditionText,
    toolTipText,
    case: estCase,
  } = refinedData;

  return (
    isPurchaseAvailable &&
    Boolean(estCase) &&
    (!isPostDeal || isLotteDeal
      ? DeliveryEstimatedDateTemplate({
          expectedDeliveryEndDate,
          averageDeliveryDays,
          fixedText,
          isLotteDeal,
          toolTipText,
        })
      : DeliveryEstimatedDatePostDealTemplate({
          expectedDeliveryEndDate,
          averageDeliveryDays,
          postConditionText,
          toolTipText,
        }))
  );
}

export default DeliveryEstimatedDate;
